import React, { useEffect } from "react";
import { X } from "@phosphor-icons/react";

export const BTN = "border-2 border-black px-3 py-1.5 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 disabled:opacity-40";
export const BTN_WHITE = `${BTN} bg-white hover:bg-black hover:text-white`;
export const BTN_BLACK = `${BTN} bg-black text-white hover:bg-emerald-700`;
export const INPUT = "mt-1 w-full border-2 border-black bg-white px-2 py-1.5 text-sm";

export const errText = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d[0]?.msg || fallback;
  return fallback;
};

export function AdminModal({ eyebrow, title, onClose, footer, children, testId, wide = false }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/50 p-4" data-testid={testId}>
      <div className={`my-8 w-full ${wide ? "max-w-6xl" : "max-w-3xl"} border-2 border-black bg-white shadow-[6px_6px_0_0_#000]`}>
        <div className="flex items-center gap-3 border-b-2 border-black px-4 py-3">
          <div>
            <div className="label-mono text-zinc-500">{eyebrow}</div>
            <div className="font-chivo text-lg font-black leading-tight" data-testid={`${testId}-title`}>{title}</div>
          </div>
          <button type="button" className="ml-auto p-1 hover:bg-zinc-100" onClick={onClose} aria-label="Close" data-testid={`${testId}-close`}>
            <X size={18} weight="bold" />
          </button>
        </div>
        <div className="p-4">{children}</div>
        {footer && <div className="flex flex-wrap justify-end gap-2 border-t-2 border-black px-4 py-3">{footer}</div>}
      </div>
    </div>
  );
}
